import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680daaa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"transform":"scale(0.35)","display":"inline-block"} }
const _hoisted_2 = { class: "flex-bwn-ter reset" }
const _hoisted_3 = { class: "prop" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "abs-wrap" }, null, -1))
const _hoisted_6 = { class: "rel flex-item-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { style: {"transform":"scale(0.35)","display":"inline-block"} }

import { t } from '@/plugins/i18n'
import { ref, reactive, computed } from 'vue'
import PriceRange from '@/components/common/PriceRange.vue'
import useCate from './cate'
import { brandQueryPage, brandQueryStyles } from '@/apis/brand'
import { useRoute, useRouter } from 'vue-router'
import { CaretTop } from '@element-plus/icons-vue'
import { useSite2Station, isMultiStore, isJA } from '@/store'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
    search: { type: Function, required: true }
  },
  setup(__props: any) {

const props = __props as {search:(a:any)=>void}


// 类目

const cate = useCate()

// 品牌
const brandQuery = reactive({
  pageNum: 1,
  pageSize: 100,
  total: 0,
  finished: false
})

// 点击展开品牌列，初始分页请求，如果全部请求完则变为收起展开功能
const onexpand = (v:any = {}) => {
  if (!brandQuery.finished) {
    brandQueryPage(brandQuery).then(res => {
      if (res.success) {
        console.log('brandQueryPage', res.data)
        const data = res.data
        brandQuery.pageNum++
        brandQuery.total = data.total + 1
        const options = data.records.map((v:any) => {
          return {
            label: v.brandName,
            value: v.brandId
          }
        })
        const index = isShowSlectCountry ? 2 : 1
        filtersOnShow.value[index].options.push(...options)
        const len = filtersOnShow.value[index].options.length
        if (len >= brandQuery.total) {
          brandQuery.finished = true
        } else {
          onexpand()
        }
      }
    })
  }
}

onexpand()

// 风格
brandQueryStyles().setSite(res => {
  console.log('brandQueryStyles', res)
  const data = res.data.map((v:any) => {
    return {
      label: v.name,
      value: v.id
    }
  }).filter((v:any) => v.label)
  // todo
  const index = isShowSlectCountry ? 3 : 2
  filtersOnShow.value[index].options.push(...data)
})

// 选项
const filters = reactive<
  {
    prop: string;
    label: string;
    expand?: boolean;
    options: {
      value: string | string[];
      label: string;
      logo?: string;
      custom?: boolean;
      active?: boolean;
    }[];
  }[]
>(
  [
    {
      prop: 'countryCode',
      label: t('品牌国家1'),
      options: [
        { value: '', label: '全部' },
        { value: 'KR', label: 'Korea', logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/KoreaIconBorder@3x.png' },
        { value: 'CN', label: 'China', logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/ChinaIcon@3x.png' }
      ].fort()
    },
    {
      prop: 'productCategoryFrontendId',
      label: '主营类目',
      expand: false,
      options: [{ value: '', label: '全部' }].fort().concat(cate.value)
    },
    {
      prop: 'brandId',
      label: '品牌_',
      expand: false,
      options: [{ value: '', label: '全部', logo: '' }].fort()
    },
    {
      prop: 'brandStyleId',
      label: '风格_',
      expand: false,
      options: [{ value: '', label: '全部' }].fort()
    },
    {
      prop: 'platformType',
      label: '采购市场_',
      options: [
        { value: '', label: '全部' },
        { value: 'AM', label: '1688' },
        { value: 'TB', label: '淘宝' },
        { value: 'TM', label: 'Tmall' }
      ].fort()
    },
    {
      prop: 'customerAuthType',
      label: '可授权形式',
      options: [
        { value: '', label: '全部_' },
        { value: '0', label: '普通授权' },
        { value: '1', label: '独家授权' }
      ].fort()
    },
    {
      prop: 'averagePrice',
      label: '均价范围',
      options: [
        { value: ['', ''], label: '全部_' },
        { value: ['50', '100'], label: '50-100' },
        { value: ['100', '200'], label: '100-200' },
        { value: ['200', '300'], label: '200-300' },
        { value: ['300', '500'], label: '300-500' },
        { value: ['', ''], label: '自定义_', custom: true }
      ].fort()
    }
  ].fort()
)

// 展开筛选
const isExtra = ref(true)

const onExtra = () => {
  isExtra.value = !isExtra.value
  filters.map(v => {
    if ('expand' in v) {
      v.expand = isExtra.value
    }
  })
}

const slice = 2

// 每行dom高度
const itemHeight = reactive<(number | string)[]>([])

const setHeight = (el: HTMLElement, i: number) => {
  itemHeight[i] = el?.getBoundingClientRect().height ?? ''
}

// 搜索条件form
const form = reactive<Record<string, string | string[]>>({
  countryCode: ''
})

const set = (prop: string, val: string | string[]) => {
  form[prop] = val
  if (prop === 'averagePrice') {
    form.averagePriceMin = val[0]
    form.averagePriceMax = val[1]
  }
  props.search(form)
}
const store = useStore()
const isLogin = computed(() => store.getters.isLogin)
// 当登录状态且为日本站点才展示
const isShowSlectCountry = isJA()
// 当为日本站点，有国家选项
const isJaSliceFour = isShowSlectCountry ? 4 : 3
// 全部收起
const retractStatus = ref(false)
//  当为日本站时才有国家品牌筛选
const filtersOnShow = ref(isShowSlectCountry ? filters : filters.slice(1))

const totalHeight = computed(() => {
  // 初始高度
  if (!itemHeight.length) {
    return isShowSlectCountry ? 297 : 261
  }
  const onShowItem = retractStatus.value ? itemHeight.slice(0, 3) : itemHeight
  const value = onShowItem.reduce((result, item, index) => {
    // 多了个国家筛选
    const max = isShowSlectCountry ? 4 : 3
    // 直接取filtersOnShow 最新数据
    const target = ((index < max) && filtersOnShow.value[index].expand) ? item : '36' // 36是item不展开的高度
    return Number(result) + Number(target)
  }, 45)
  return value
})
const retract = () => {
  filters.forEach(v => {
    if ('expand' in v) {
      v.expand = false
    }
  })
  //   若是没有国家筛选
  const newFilters = isShowSlectCountry ? filters : filters.slice(1)
  retractStatus.value = !retractStatus.value
  // 收起
  if (retractStatus.value) {
    filtersOnShow.value = newFilters.slice(0, 3)
    return
  }
  // 展开
  const showMoreFilter = () => {
    // 展开的时候给filter一行行展示出来 动画好看点
    if (filtersOnShow.value.length === newFilters.length) {
      clearInterval(timer)
      return
    }
    filtersOnShow.value = newFilters.slice(0, filtersOnShow.value.length + 1)
  }
  const timer = setInterval(showMoreFilter, 50)
}
// 这么搞动画很丑 所以在retract事件里手动控制filtersOnShow
// const filtersOnShow = computed(() => {
//   return retractStatus.value ? filters.slice(0, 3) : filters
// })

// 重置
const route = useRoute()
const router = useRouter()
const reset = () => {
  if (JSON.stringify(route.query) !== '{}') {
    router.replace(route.path)
  }
  Object.keys(form).forEach((i:any) => {
    delete form[i]
  })
  filtersOnShow.value.forEach(i => {
    if (i.prop === 'averagePrice') {
      i.options[i.options.length - 1].value = ['', '']
    }
  })
  props.search(form)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "list-label mb_10 rel",
    style: _normalizeStyle({height: `${_unref(totalHeight)}px`})
  }, [
    _createElementVNode("div", {
      class: "list-retract abs flex-cen-ter cursor-pt",
      onClick: retract
    }, [
      _createTextVNode(_toDisplayString(retractStatus.value?_unref(t)('展开筛选条件'):_unref(t)('收起筛选条件')), 1),
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(["iconfont icon-zhankai", { turnDown: retractStatus.value, turnUp: !retractStatus.value }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('筛选条件1')), 1),
      _createElementVNode("div", {
        class: "resetBtn flex-cen-ter cursor-pt",
        onClick: reset
      }, _toDisplayString(_unref(t)('重置')), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtersOnShow.value, (v, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: v.label,
        class: _normalizeClass(["label-item", {
        hidden: i > slice && !isExtra.value,
        'hide-border': i === slice && !isExtra.value,
        collapse: (i<_unref(isJaSliceFour)) && !v.expand,
      }]),
        style: _normalizeStyle({ height: _unref(itemHeight)[i] ? _unref(itemHeight)[i] + 'px' : 'auto', maxHeight: i<_unref(isJaSliceFour)?'216px':'' })
      }, [
        _createElementVNode("div", {
          class: "rel flex",
          ref: (el) => setHeight(el as HTMLElement, i)
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(v.label), 1),
          _createElementVNode("div", {
            class: "flex-wrap label-values",
            style: _normalizeStyle({maxHeight: (i<_unref(isJaSliceFour))?'216px':'',overflow: (i<4)&&v.expand?'auto':'hidden'})
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.options, (opt) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["value flex-ter", _unref(form)[v.prop]===opt.value&&'active']),
                key: opt.label
              }, [
                _createElementVNode("div", {
                  class: "label-text rel",
                  onClick: ($event: any) => (set(v.prop, opt.value))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    (opt.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"width":"12px","height":"12px","margin-right":"1px"},
                          alt: "",
                          src: opt.logo
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(opt.label), 1)
                  ])
                ], 8, _hoisted_4),
                (opt.custom)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(PriceRange, {
                        small: "",
                        class: "ml_10",
                        min: opt.value[0],
                        "onUpdate:min": ($event: any) => ((opt.value[0]) = $event),
                        max: opt.value[1],
                        "onUpdate:max": ($event: any) => ((opt.value[1]) = $event)
                      }, null, 8, ["min", "onUpdate:min", "max", "onUpdate:max"]),
                      (opt.value[0] || opt.value[1])
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            style: {"height":"28px"},
                            class: "ml_10",
                            size: "small",
                            type: "primary",
                            onClick: ($event: any) => (set(v.prop, opt.value))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ], 4),
          ('expand' in v)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "abs expand",
                style: {"right":"20px"},
                onClick: ($event: any) => (v.expand=!v.expand)
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)(v.expand?'收起筛选':'展开更多')), 1),
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["iconfont icon-zhankai", { rotate: v.expand }])
                    }, null, 2)
                  ])
                ])
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ], 512)
      ], 6))
    }), 128))
  ], 4))
}
}

})